import React, { useEffect, useCallback, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import * as Three from 'three';
import toast from 'react-hot-toast';
import store from '../../../../../redux/store';
import { getAssetIcon } from '../utils/GetAssetIcon';
import { handleRename } from '../../RenameAsset';
import {
  SubMenuPortal,
  SimpleAssetTooltip,
} from '../../../../../utils/gridUtils';
import { duplicateImageAsset } from '../../../../../components/gridpagefunction/image';
import {
  duplicateMeshAsset,
  resolveMeshInScene,
} from '../../../../../components/gridpagefunction/Mesh';
import { duplicateVideoAsset } from '../../../../../components/gridpagefunction/Video';
import { duplicateAudioAsset } from '../../../../../components/gridpagefunction/Audio';
import { getParticleDisplayName } from '../../../../../utils/utils';
import { handleAddText } from '../../../../../components/gridpagefunction/Text';
import {
  handleAddHotSpot,
  duplicateHotspot,
} from '../../../../../components/gridpagefunction/HotSpot';
import {
  removeCamera,
  selected_object,
  update_assets_data,
  lightDataUpdate,
} from '../../../../../redux/Slice/gridSlice';
import {
  setSelectedLightId,
  updateActiveComponent,
  setIsConfirmationOpen,
} from '../../../../../redux/Slice/globalStates';
// Removed separate CameraListItem and LightListItem imports - now using unified system
import { RecursiveChildRenderer } from './RecursiveChildRenderer';
import { useHierarchyUtils } from '../utils/hierarchyUtils';
import {
  getActiveParentForChildSelection,
  isChildSelectionEnabled,
  toggleChildSelectionMode,
} from '../../../../../pages/Dashboard/GridPage';
import {
  clampSelectionForChildMode,
  collectGlbHierarchyExpandKeys,
  glbPivotContainsObjectUuid,
} from '../../../../../components/gridpagefunction/MeshExtractation';
// import { removeCamera, selected_object, update_assets_data } from '../../../../../redux/Slice/gridSlice';
// import { setIsConfirmationOpen, setSelectedLightId, updateActiveComponent } from '../../../../../redux/Slice/globalStates';
import CameraListItem from '../../CameraListItem';
import LightListItem from '../../LightListItem';
// import { RecursiveChildRenderer } from './RecursiveChildRenderer';
import { find, set } from 'lodash';
import { pasteItem } from '../../../../Copy-Paste';
import useClickOutside from '../../../../UseClickOutside';
import { EmptyObject } from '../../EmptyObject';
import { duplicateParticleAsset } from '../../../../../utils/particles/HandleDuplicatePartical';
import { updateParticle } from '../../../../../redux/Slice/particleSlice';
import AssetVisibilityToggle from './AssetVisibilityToggle';
import {
  REFERENCE_OBJECT_EVENT,
  REFERENCE_OBJECT_LABEL,
  getReferenceObject,
  toggleReferenceObjectVisibility,
} from '../../../../gridpagefunction/referenceobject';
import {
  isAssetVisible,
  resolveAssetRowId,
  resolveLiveSceneObject,
  resolveSceneObject,
  toggleAssetVisibility,
} from '../../../../../utils/ThreeJsUtils/assetVisibilityUtils';
import {
  getCameraStableId,
  resolveSceneCameraObject,
} from '../../../../../utils/ThreeJsUtils/sceneCameraUtils';
import {
  isHierarchyRowSelected,
  toggleHierarchyItemSelection,
} from '../../../../../utils/selectAllObjects';
import { hasDisplayName } from '../../../../../utils/gridHistoryAssetsSync';
import {
  captureDiscreteHistoryBefore,
  recordDiscreteHistoryAfter,
} from '../../../../../utils/gridHistoryDiscrete';
import { suppressGridHistory } from '../../../../../utils/gridHistorySuppress';

const shouldShowAssetInLeftPanel = (scene, item, arrKey) => {
  if (!item) return false;
  if (hasDisplayName(item)) return true;
  return !!resolveLiveSceneObject(scene, item, arrKey);
};

const AssetsList = ({
  scene,
  assets_data,
  light_data,
  camera_properties,
  particles,
  select_object,
  selectedObject,
  selectedLightId,
  expandedGLBs,
  setExpandedGLBs,
  glbMeshes,
  setGLBMeshes,
  selectedPop,
  setselectedPop,
  allAssets,
  selectedLightPop,
  setSelectedLightPop,
  selectedGLBMeshPop,
  setSelectedGLBMeshPop,
  selectedCameraPop,
  setSelectedCameraPop,
  submenuPosition,
  setSubmenuPosition,
  lightSubmenuPosition,
  setLightSubmenuPosition,
  glbMeshSubmenuPosition,
  setGLBMeshSubmenuPosition,
  cameraSubmenuPosition,
  setCameraSubmenuPosition,
  isRenaming,
  setIsRenaming,
  renamingItem,
  setRenamingItem,
  newName,
  setNewName,
  isRenamingLight,
  setIsRenamingLight,
  renamingLight,
  setRenamingLight,
  newLightName,
  setNewLightName,
  draggingAssetId,
  setDraggingAssetId,
  hoverTargetAssetId,
  setHoverTargetAssetId,
  collapsedMap,
  toggleCollapsed,
  cameraRemoved,
  objectt,
  store,
  dispatch,
  selectObjectInScene,
  setSelectedObjectState,
  handleDropOnAsset,
  handleDropToRoot,
  findDirectChildrenAssets,
  renderChildren,
  handleRemoveLight,
  handleRemoveParticle,
  handleRemoveCamera,
  handleSelectParticle,
  memoizedExtractMeshesFromGLB,
  outSideRef,
  iconsPath,
  shapesIcon,
  assetIcons,
  hierarchyUpdateTrigger,
  DeleteMesh,
}) => {
  const selectedMeshesForGrouping = useSelector(
    (state) => state.assets_object.selectedMeshesForGrouping ?? []
  );

  // Editor-only reference (dummy) character shown for VR/MR projects. Tracked
  // straight off the live scene so the section only appears when it exists.
  const [referenceInfo, setReferenceInfo] = useState({
    present: false,
    visible: true,
  });

  useEffect(() => {
    const syncReference = () => {
      const obj = getReferenceObject(scene);
      setReferenceInfo({
        present: !!obj,
        visible: obj ? obj.visible !== false : true,
      });
    };

    syncReference();
    window.addEventListener(REFERENCE_OBJECT_EVENT, syncReference);
    return () =>
      window.removeEventListener(REFERENCE_OBJECT_EVENT, syncReference);
  }, [scene, hierarchyUpdateTrigger]);

  const handleToggleReferenceVisibility = useCallback(() => {
    const nextVisible = toggleReferenceObjectVisibility(scene);
    setReferenceInfo((prev) => ({ ...prev, visible: nextVisible }));
  }, [scene]);

  const isRowSelected = (item, type) =>
    isHierarchyRowSelected(select_object, selectedMeshesForGrouping, {
      item,
      type,
      scene,
    });

  const handleGridItemClick = (e, item, type, singleSelect) => {
    if (e?.ctrlKey || e?.metaKey) {
      e.stopPropagation();
      toggleHierarchyItemSelection({
        scene,
        item,
        type,
        transformControls: objectt?.transformControls,
        onPrimarySelected: setSelectedObjectState,
      });
      return;
    }
    singleSelect?.();
  };

  const [assetsPopup, setAssetsPopup] = useState(null);
  const [assetsPopupPosition, setAssetsPopupPosition] = useState({
    top: 0,
    left: 0,
  });

  // Unified popup state for all assets
  const [unifiedPopup, setUnifiedPopup] = useState({
    isOpen: false,
    assetId: null,
    assetType: null,
    assetItem: null,
    position: { top: 0, left: 0 },
  });

  // Unified rename state
  const [unifiedRename, setUnifiedRename] = useState({
    isRenaming: false,
    assetId: null,
    assetType: null,
    newName: '',
    assetItem: null,
  });

  // Ref for rename input
  const renameInputRef = useRef(null);

  // Ref for auto-scroll to selected item
  const containerRef = useRef(null);

  // Effect to focus and set cursor position when renaming starts
  useEffect(() => {
    if (unifiedRename.isRenaming && renameInputRef.current) {
      renameInputRef.current.focus();
      renameInputRef.current.setSelectionRange(
        unifiedRename.newName.length,
        unifiedRename.newName.length
      );
    }
  }, [unifiedRename.isRenaming]);

  useClickOutside(outSideRef, () => {
    setAssetsPopup(null);
    setUnifiedPopup({
      isOpen: false,
      assetId: null,
      assetType: null,
      assetItem: null,
      position: { top: 0, left: 0 },
    });
  });

  // Unified handlers for all asset types
  const handleUnifiedMenuClick = (e, assetId, assetType, assetItem) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    setUnifiedPopup({
      isOpen: true,
      assetId,
      assetType,
      assetItem,
      position: {
        top: rect.top - 10,
        left: rect.right + 10,
      },
    });
  };

  const handleVisibilityToggle = useCallback(
    (item, type, arrKey, objectId) => {
      toggleAssetVisibility({
        scene,
        item,
        type,
        arrKey,
        objectId,
      });
    },
    [scene]
  );

  const handleUnifiedRename = (assetId, assetType, assetItem) => {
    setUnifiedRename({
      isRenaming: true,
      assetId,
      assetType,
      assetItem,
      newName:
        assetItem?.file_name ||
        assetItem?.asset_file_name ||
        assetItem?.temp_file_name ||
        (assetType === 'light'
          ? assetItem?.name && assetItem?.name !== assetId
            ? assetItem?.name
            : assetItem?.light_type || 'Light'
          : assetType === 'camera'
            ? assetItem?.name && assetItem?.name !== assetId
              ? assetItem?.name
              : assetItem?.file_name || 'Camera'
            : assetType === 'particle'
              ? assetItem?.file_name ||
                assetItem?.temp_file_name ||
                assetItem?.name ||
                'Particle'
              : assetType === 'mesh'
                ? assetItem?.file_name || assetItem?.name || 'Mesh'
                : assetItem?.file_name || assetItem?.name || 'Object') ||
        '',
    });
    setUnifiedPopup({
      isOpen: false,
      assetId: null,
      assetType: null,
      assetItem: null,
      position: { top: 0, left: 0 },
    });
  };

  const handleUnifiedDuplicate = (assetId, assetType, assetItem) => {
    if (assetType === 'mesh' && assetItem?.parentGLB) {
      const parentGLBId = assetItem.parentGLB._id || assetItem.parentGLB.id;
      const originalObj = assetItem.object;
      if (!originalObj) return;

      const clonedObj = originalObj.clone();

      // ✅ Count existing copies to determine next number
      const baseName = (
        assetItem.file_name ||
        assetItem.name ||
        originalObj.name
      ).replace(/\s*\(\d+\)$/, '');

      // Count existing copies with (n) pattern
      const existingCopies = (glbMeshes[parentGLBId] || []).filter(
        (m) =>
          (m.file_name || m.name || '').startsWith(baseName) &&
          /\s*\(\d+\)$/.test(m.file_name || m.name || '')
      );
      const copyNumber = existingCopies.length + 1;
      const copyName = `${baseName} (${copyNumber})`;

      clonedObj.name = copyName;

      const parentNode = originalObj.parent;
      if (parentNode) {
        parentNode.add(clonedObj);

        const children = parentNode.children;
        const originalIndex = children.findIndex(
          (c) => c.uuid === originalObj.uuid
        );
        const cloneIndex = children.findIndex((c) => c.uuid === clonedObj.uuid);

        if (originalIndex !== -1 && cloneIndex !== -1) {
          children.splice(cloneIndex, 1);
          children.splice(originalIndex + 1, 0, clonedObj);
        }
      } else {
        scene.add(clonedObj);
      }

      const newMeshEntry = {
        ...assetItem,
        id: clonedObj.uuid,
        name: copyName,
        file_name: copyName, // ✅ clean name like Object_7_copy1
        object: clonedObj,
        parentGLB: assetItem.parentGLB,
      };

      setGLBMeshes((prev) => {
        const existingMeshes = prev[parentGLBId] || [];
        const originalIndex = existingMeshes.findIndex(
          (m) =>
            m.id === assetItem.id || m.object?.uuid === assetItem.object?.uuid
        );
        const insertAt =
          originalIndex !== -1 ? originalIndex + 1 : existingMeshes.length;

        return {
          ...prev,
          [parentGLBId]: [
            ...existingMeshes.slice(0, insertAt),
            newMeshEntry,
            ...existingMeshes.slice(insertAt),
          ],
        };
      });

      setTimeout(() => {
        if (memoizedExtractMeshesFromGLB && assetItem.parentGLB) {
          const freshMeshes = memoizedExtractMeshesFromGLB(assetItem.parentGLB);
          if (freshMeshes.length > 0) {
            setGLBMeshes((prev) => ({
              ...prev,
              [parentGLBId]: freshMeshes,
            }));
          }
        }
      }, 50);

      selectObjectInScene(clonedObj.name);
      setSelectedObjectState(clonedObj);
      store.dispatch(selected_object(clonedObj));

      setUnifiedPopup({
        isOpen: false,
        assetId: null,
        assetType: null,
        assetItem: null,
        position: { top: 0, left: 0 },
      });
      return;
    }

    const originalMesh = resolveMeshInScene(
      scene,
      assetItem,
      scene.getObjectByName(assetId)
    );
    handleDuplicate(assetItem, assetType, originalMesh);
    setUnifiedPopup({
      isOpen: false,
      assetId: null,
      assetType: null,
      assetItem: null,
      position: { top: 0, left: 0 },
    });
  };

  const handleUnifiedDelete = (assetId, assetType, assetItem) => {
    let objectName = assetId;
    let objToSelect = null;

    // Handle GLB mesh deletion specially
    if (assetItem && assetItem.object && assetItem.parentGLB) {
      // Use object reference directly — name may collide across duplicates
      objToSelect = assetItem.object;
      objectName =
        objToSelect.uuid || objToSelect.name || assetItem.name || assetId;
    } else {
      // Regular asset - try to find by name first, then by UUID if needed
      objToSelect = scene.getObjectByName(assetId);

      if (!objToSelect) {
        scene.traverse((child) => {
          if (
            !objToSelect &&
            (child.name === assetId ||
              child.uuid === assetId ||
              child._id === assetId ||
              child.userData?.id === assetId)
          ) {
            objToSelect = child;
          }
        });
      }

      if (!objToSelect && assetItem) {
        const possibleIds = [
          assetItem._id,
          assetItem.id,
          assetItem.name,
          assetItem.url,
          assetItem.object?.name,
          assetItem.object?.uuid,
        ].filter(Boolean);

        for (const id of possibleIds) {
          objToSelect = scene.getObjectByName(id);
          if (objToSelect) {
            objectName = id;
            break;
          }
        }
      }
    }

    // Select the object in scene
    if (objToSelect) {
      selectObjectInScene(objToSelect.name || objectName);
      setSelectedObjectState(objToSelect);
      store.dispatch(selected_object(objToSelect));
    } else {
      let foundObj = null;
      scene.traverse((child) => {
        if (
          !foundObj &&
          (child.name === objectName ||
            child.uuid === objectName ||
            child._id === objectName ||
            child.userData?.id === objectName ||
            (assetItem &&
              (child.name === assetItem.name ||
                child.uuid === assetItem.id ||
                child._id === assetItem._id)))
        ) {
          foundObj = child;
        }
      });

      if (foundObj) {
        selectObjectInScene(foundObj.name);
        setSelectedObjectState(foundObj);
        store.dispatch(selected_object(foundObj));
      } else {
        selectObjectInScene(objectName);
        const fallbackObj = scene.getObjectByName(objectName);
        if (fallbackObj) {
          setSelectedObjectState(fallbackObj);
          store.dispatch(selected_object(fallbackObj));
        } else {
          console.warn('Could not find object to delete:', {
            objectName,
            assetId,
            assetType,
            assetItem,
          });
        }
      }
    }

    // ✅ ADD THIS: Handle empty object deletion from Redux state
    if (assetType === 'empty') {
      const updatedEmptyObjects =
        assets_data.empty?.filter(
          (emptyObj) =>
            emptyObj._id !== assetId &&
            emptyObj.id !== assetId &&
            emptyObj.name !== assetId
        ) || [];

      dispatch(
        update_assets_data({
          type: 'empty',
          data: updatedEmptyObjects,
        })
      );

      // Remove from Three.js scene
      const emptyObjInScene = scene.getObjectByName(assetId);
      if (emptyObjInScene) {
        scene.remove(emptyObjInScene);
      }

      setUnifiedPopup({
        isOpen: false,
        assetId: null,
        assetType: null,
        assetItem: null,
        position: { top: 0, left: 0 },
      });

      return; // ✅ Early return — skip the confirmation dialog
    }

    if (assetType === 'camera') {
      // For cameras, we use the camera's id/_id as the identifier
      const cameraId = assetItem?._id || assetItem?.id || assetId;
      const cameraObj = scene.getObjectByName(cameraId);
      if (cameraObj) {
        selectObjectInScene(cameraObj.name);
        setSelectedObjectState(cameraObj);
        store.dispatch(selected_object(cameraObj));
      }
      // Delegate actual removal to the shared camera remove handler
      handleRemoveCamera(cameraId);
      setUnifiedPopup({
        isOpen: false,
        assetId: null,
        assetType: null,
        assetItem: null,
        position: { top: 0, left: 0 },
      });
      return;
    }

    setUnifiedPopup({
      isOpen: false,
      assetId: null,
      assetType: null,
      assetItem: null,
      position: { top: 0, left: 0 },
    });
    dispatch(setIsConfirmationOpen(true));
  };

  const handleRenameSubmit = () => {
    if (!unifiedRename.newName.trim()) return;

    const { assetId, assetType } = unifiedRename;

    // Handle rename based on asset type
    if (assetType === 'light') {
      const updatedLightData = light_data.map((light) =>
        light.id === assetId || light._id === assetId
          ? { ...light, name: unifiedRename.newName }
          : light
      );
      dispatch(lightDataUpdate(updatedLightData));
    } else if (assetType === 'camera') {
      const updatedCameras = camera_properties.map((camera) => {
        if (camera._id === assetId || camera.id === assetId) {
          // Display label only — keep _id / id / temp_file_name as stable scene keys.
          return {
            ...camera,
            name: unifiedRename.newName,
            file_name: unifiedRename.newName,
          };
        }
        return camera;
      });
      dispatch(update_assets_data({ type: 'camera', data: updatedCameras }));
    } else if (assetType === 'empty') {
      const updatedEmpties = assets_data?.empty?.map((emptyObj) => {
        const emptyId = emptyObj._id || emptyObj.id || emptyObj.name;
        if (emptyId === assetId) {
          return {
            ...emptyObj,
            file_name: unifiedRename.newName,
            temp_file_name: unifiedRename.newName,
          };
        }
        return emptyObj;
      });
      if (updatedEmpties) {
        dispatch(update_assets_data({ type: 'empty', data: updatedEmpties }));
      }
    } else if (assetType === 'mesh') {
      // Check if this is a GLB mesh child
      if (unifiedRename.assetItem?.parentGLB) {
        // Handle GLB mesh child rename
        const parentGLBId =
          unifiedRename.assetItem.parentGLB._id ||
          unifiedRename.assetItem.parentGLB.id;

        // Update Three.js mesh object name
        if (
          unifiedRename.assetItem.object &&
          !Object.isFrozen(unifiedRename.assetItem.object)
        ) {
          unifiedRename.assetItem.object.name = unifiedRename.newName;
        }

        // Update glbMeshes state
        setGLBMeshes((prev) => ({
          ...prev,
          [parentGLBId]:
            prev[parentGLBId]?.map((mesh) =>
              mesh.id === unifiedRename.assetItem.id ||
              mesh.name === unifiedRename.assetItem.name
                ? {
                    ...mesh,
                    name: unifiedRename.newName,
                    file_name: unifiedRename.newName,
                  }
                : mesh
            ) || [],
        }));
      } else {
        // Handle regular mesh rename
        const updatedAssets = assets_data[assetType]?.map((asset) => {
          const assetIdCheck = asset._id || asset?.url || asset?.name;
          if (assetIdCheck === assetId) {
            // Update the scene object's file_name (safely)
            const sceneObj = scene.getObjectByName(assetId);
            if (sceneObj && !Object.isFrozen(sceneObj)) {
              try {
                // NOTE: Do NOT change sceneObj.name — it is the unique scene identifier
                // used by scene.getObjectByName(). Changing it breaks panel-click selection.
                // Only update the display label (file_name / userData.file_name).
                const descriptor = Object.getOwnPropertyDescriptor(
                  sceneObj,
                  'file_name'
                );
                if (!descriptor || descriptor.writable !== false) {
                  sceneObj.file_name = unifiedRename.newName;
                }
                // Always update userData if it exists and is not frozen
                if (sceneObj.userData && !Object.isFrozen(sceneObj.userData)) {
                  sceneObj.userData.file_name = unifiedRename.newName;
                }
              } catch (error) {
                console.warn('Could not update scene object file_name:', error);
                // Continue without updating scene object
              }
            }

            return {
              ...asset,
              file_name: unifiedRename.newName,
              // Keep the name (ID) as is, update file_name
            };
          }
          return asset;
        });
        if (updatedAssets) {
          dispatch(
            update_assets_data({ type: assetType, data: updatedAssets })
          );
        }
      }
    } else if (
      ['image', 'video', 'audio', 'text', 'hotspot'].includes(assetType)
    ) {
      // ✅ UPDATE BOTH file_name AND the scene object
      const updatedAssets = assets_data[assetType]?.map((asset) => {
        const assetIdCheck = asset._id || asset?.url || asset?.name;
        if (assetIdCheck === assetId) {
          // Update the scene object's file_name (safely)
          const sceneObj = scene.getObjectByName(assetId);
          if (sceneObj && !Object.isFrozen(sceneObj)) {
            try {
              // Check if file_name property is writable
              const descriptor = Object.getOwnPropertyDescriptor(
                sceneObj,
                'file_name'
              );
              if (!descriptor || descriptor.writable !== false) {
                sceneObj.file_name = unifiedRename.newName;
              }
              // Always update userData if it exists and is not frozen
              if (sceneObj.userData && !Object.isFrozen(sceneObj.userData)) {
                sceneObj.userData.file_name = unifiedRename.newName;
              }
            } catch (error) {
              console.warn('Could not update scene object file_name:', error);
              // Continue without updating scene object
            }
          }

          return {
            ...asset,
            file_name: unifiedRename.newName,
            // Keep the name (ID) as is, update file_name
          };
        }
        return asset;
      });
      if (updatedAssets) {
        dispatch(update_assets_data({ type: assetType, data: updatedAssets }));
      }
    } else if (assetType === 'particle') {
      dispatch(
        updateParticle({
          id: assetId,
          updates: { name: unifiedRename.newName },
        })
      );
    }

    setUnifiedRename({
      isRenaming: false,
      assetId: null,
      assetType: null,
      newName: '',
      assetItem: null,
    });
  };
  const handleDuplicateLight = (lightItem) => {
    const original = scene.getObjectByName(
      lightItem._id || lightItem.id || lightItem.url || lightItem.name
    );
    const itemToPaste = {
      type: 'light',
      data: {
        ...lightItem,
        // Generate a new unique ID for the duplicate
        _id: undefined, // Let pasteItem generate a new one
        id: undefined,
        position: original
          ? {
              x: original.position.x,
              y: original.position.y,
              z: original.position.z,
            }
          : lightItem.position,
        rotation: original
          ? {
              x: Three.MathUtils.radToDeg(original.rotation.x),
              y: Three.MathUtils.radToDeg(original.rotation.y),
              z: Three.MathUtils.radToDeg(original.rotation.z),
            }
          : lightItem.rotation,
        scale: original
          ? { x: original.scale.x, y: original.scale.y, z: original.scale.z }
          : lightItem.scale,
      },
    };

    // Clear current selection first
    setSelectedLightPop('');

    const paste = pasteItem({
      dispatch,
      scene,
      selectObjectInScene,
      setSelectedObjectState,
      setAdditionalCameras: () => {},
    });

    paste(itemToPaste);
  };

  const handleDuplicateCamera = (cameraItem) => {
    // Get the actual Three.js camera object from the scene
    const cameraObj = scene.getObjectByName(cameraItem._id || cameraItem.id);

    if (!cameraObj || !cameraObj.isCamera) {
      console.error('Camera object not found in scene');
      return;
    }

    // Use the current display name (renamed) when duplicating
    const baseName =
      cameraItem.name ||
      cameraItem.file_name ||
      cameraItem.temp_file_name ||
      cameraObj.name ||
      'Camera';
    const existingCopies =
      camera_properties?.filter((cam) => {
        const name = cam.name || cam.file_name || cam.temp_file_name || '';
        return name.startsWith(`${baseName}_copy`);
      }) || [];

    const itemToPaste = {
      type: 'camera',
      data: {
        type: cameraObj.type, // 'PerspectiveCamera' or 'OrthographicCamera'
        name: `${baseName}_copy ${existingCopies.length + 1}`,
        fov: cameraObj.fov,
        aspect: cameraObj.aspect,
        near: cameraObj.near,
        far: cameraObj.far,
        left: cameraObj.left,
        right: cameraObj.right,
        top: cameraObj.top,
        bottom: cameraObj.bottom,
        zoom: cameraObj.zoom,
        position: cameraObj.position.toArray(),
        rotation: cameraObj.rotation.toArray(),
        scale: cameraObj.scale.toArray(),
      },
    };

    setselectedPop('');

    const paste = pasteItem({
      dispatch,
      scene,
      selectObjectInScene,
      setSelectedObjectState,
      setAdditionalCameras: () => {},
    });

    paste(itemToPaste);
  };

  const handleDuplicateHotspot = (hotspotItem) => {
    const newHotspotGroup = duplicateHotspot(hotspotItem, objectt);
    if (newHotspotGroup) {
      toast.success('Hotspot duplicated successfully!');
    }
    setselectedPop('');
  };

  const handleDuplicateEmpty = (emptyItem) => {
    const newId = `Empty_${Date.now()}`;

    // Create new Three.js Object3D in scene
    const original = scene.getObjectByName(
      emptyItem._id || emptyItem.id || emptyItem.url || emptyItem.name
    );
    const newEmpty = new Three.Object3D();
    newEmpty.name = newId;

    if (original) {
      newEmpty.position.copy(original.position);
      newEmpty.rotation.copy(original.rotation);
      newEmpty.scale.copy(original.scale);
    }

    scene.add(newEmpty);

    // Add to Redux state
    const existingEmpties = assets_data?.empty || [];
    const baseName =
      emptyItem.file_name ||
      emptyItem.temp_file_name ||
      emptyItem.name ||
      'Empty';
    const copies = existingEmpties.filter((e) =>
      (e.file_name || e.name || '').startsWith(`${baseName}_copy`)
    );

    const newEmptyData = {
      ...emptyItem,
      _id: newId,
      id: newId,
      name: newId,
      file_name: `${baseName}_copy ${copies.length + 1}`,
      temp_file_name: `${baseName}_copy ${copies.length + 1}`,
    };

    dispatch(
      update_assets_data({
        type: 'empty',
        data: [...existingEmpties, newEmptyData],
      })
    );

    // Select the new empty
    selectObjectInScene(newId);
    setSelectedObjectState(newEmpty);
    store.dispatch(selected_object(newEmpty));
  };

  // Function to add a new camera
  const handleAddCamera = () => {
    const newCameraId = `Camera_${Date.now()}`;
    const newCamera = new Three.PerspectiveCamera(
      50,
      window.innerWidth / window.innerHeight,
      0.1,
      10
    );
    newCamera.name = newCameraId;
    newCamera.position.set(0, 0, 5);
    scene.add(newCamera);

    const itemToPaste = {
      type: 'camera',
      data: {
        type: 'PerspectiveCamera',
        fov: 50,
        aspect: window.innerWidth / window.innerHeight,
        near: 0.1,
        far: 10,
        position: [0, 0, 5],
        rotation: [0, 0, 0],
        scale: [1, 1, 1],
        _id: newCameraId,
        id: newCameraId,
      },
    };

    const paste = pasteItem({
      dispatch,
      scene,
      selectObjectInScene,
      setSelectedObjectState,
      setAdditionalCameras: () => {},
    });
    paste(itemToPaste);

    setAssetsPopup(null);
  };
  // Get hierarchy utilities including deleteAllChildren and cleanupParentReferences
  const { deleteAllChildren, cleanupParentReferences } = useHierarchyUtils({
    scene,
    assets_data,
    light_data,
    camera_properties,
    particles,
    allAssets,
  });

  // Run extraction twice: once immediately, once after delay (GLBs load async so scene is empty on first run)
  const [glbExtractionRun, setGlbExtractionRun] = useState(0);

  // Reset when mesh list changes so we get two fresh runs for the new list
  useEffect(() => {
    setGlbExtractionRun(0);
  }, [assets_data?.mesh]);

  // Handle GLB mesh extraction — always run twice when we have GLB assets: run 0 now, run 1 after delay
  useEffect(() => {
    const runExtraction = () => {
      const newGLBMeshes = {};
      assets_data?.mesh?.forEach((meshAsset) => {
        const pathOrName =
          meshAsset.asset_file_path ||
          meshAsset.userData?.hierarchySourceGlbUrl ||
          meshAsset.file_name ||
          meshAsset.url ||
          '';
        const isGlb =
          typeof pathOrName === 'string' &&
          pathOrName.toLowerCase().includes('.glb');
        if (!isGlb) return;

        const meshes = memoizedExtractMeshesFromGLB(meshAsset);
        if (meshes.length > 0) {
          newGLBMeshes[meshAsset._id || meshAsset.name] = meshes;
        }
      });
      setGLBMeshes(newGLBMeshes);
    };

    runExtraction();

    // When we have GLB assets, run extraction a second time after delay so we catch GLBs that load async
    const hasGlb = assets_data?.mesh?.some((meshAsset) => {
      const pathOrName =
        meshAsset.asset_file_path ||
        meshAsset.userData?.hierarchySourceGlbUrl ||
        meshAsset.file_name ||
        meshAsset.url ||
        '';
      return (
        typeof pathOrName === 'string' &&
        pathOrName.toLowerCase().includes('.glb')
      );
    });
    if (hasGlb && glbExtractionRun < 1) {
      const t = setTimeout(() => {
        setGlbExtractionRun(1);
      }, 1000);
      return () => clearTimeout(t);
    }
  }, [
    scene.children,
    scene.children?.length,
    assets_data?.mesh,
    memoizedExtractMeshesFromGLB,
    hierarchyUpdateTrigger,
    glbExtractionRun,
  ]);

  // Handle Shift+R keyboard shortcut for rename
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Disable rename/focus shortcuts in preview mode
      const window_type = store.getState()?.window?.window_type;
      if (window_type === 'preview') return;

      // Check if Shift+R is pressed
      if (e.shiftKey && (e.code === 'KeyR' || e.key === 'R' || e.key === 'r')) {
        e.preventDefault();

        // If there's a selected object, trigger rename
        // Traverse up to find a selectable parent if the current object isn't directly in allAssets
        // This is necessary for particle systems which use THREE.Points as children
        let currentObj = select_object;
        let assetId = null;
        let assetType = null;
        let assetItem = null;

        while (currentObj) {
          // Search in allAssets first (contains prepared items for all types including lights, cameras, particles)
          const foundInAll = allAssets?.find(({ item }) => {
            const itemIds = [
              item._id,
              item.id,
              item.name,
              item.url,
              item.file_name,
              item.temp_file_name,
              item.uuid,
            ].filter(Boolean);

            const objIds = [
              currentObj._id,
              currentObj.name,
              currentObj.url,
              currentObj.uuid,
            ].filter(Boolean);

            return objIds.some((id) => itemIds.includes(id));
          });

          if (foundInAll) {
            assetType = foundInAll.type;
            assetItem = foundInAll.item;
            assetId =
              assetItem._id ||
              assetItem.id ||
              currentObj.name ||
              currentObj._id;
            break;
          }

          // If not found, check GLB mesh children
          for (const parentGLBId in glbMeshes) {
            const glbMeshArray = glbMeshes[parentGLBId];
            if (Array.isArray(glbMeshArray)) {
              const foundMesh = glbMeshArray.find(
                (mesh) =>
                  mesh.id === currentObj?.uuid ||
                  mesh.name === currentObj?.name ||
                  mesh.object?.uuid === currentObj?.uuid
              );
              if (foundMesh) {
                assetType = 'mesh';
                assetItem = foundMesh;
                assetId = foundMesh.id || currentObj.uuid;
                break;
              }
            }
          }

          if (assetType) break;
          currentObj = currentObj.parent;
        }

        if (assetType && assetItem) {
          handleUnifiedRename(assetId, assetType, assetItem);
        } else {
          toast.error('Please select an object to rename.');
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [
    select_object,
    assets_data,
    light_data,
    camera_properties,
    particles,
    glbMeshes,
    allAssets,
    handleUnifiedRename,
  ]);

  // Listen for GLB mesh deletion events to update glbMeshes state
  useEffect(() => {
    const handleGLBMeshDeleted = (event) => {
      const { meshName, meshUuid, glbId } = event.detail;

      setGLBMeshes((prev) => {
        const updated = { ...prev };
        let found = false;

        // Try to find the correct GLB parent in glbMeshes
        // The glbId might be an asset _id, name, file_name, or url
        // We need to search through all keys in glbMeshes and filter out the deleted mesh

        Object.keys(updated).forEach((key) => {
          if (updated[key] && Array.isArray(updated[key])) {
            // Check if this is the right GLB parent by comparing various identifiers
            // If the mesh is found in this GLB, filter it out
            const originalLength = updated[key].length;
            updated[key] = updated[key].filter(
              (mesh) =>
                mesh.id !== meshUuid &&
                mesh.object?.uuid !== meshUuid &&
                mesh.name !== meshName &&
                mesh.object?.name !== meshName
            );

            // If a mesh was removed, mark as found
            if (updated[key].length < originalLength) {
              found = true;
            }

            // If no meshes left, remove the GLB entry
            if (updated[key].length === 0) {
              delete updated[key];
            }
          }
        });

        return updated;
      });
    };

    window.addEventListener('glbMeshDeleted', handleGLBMeshDeleted);
    return () => {
      window.removeEventListener('glbMeshDeleted', handleGLBMeshDeleted);
    };
  }, []);

  // Listen for GLB mesh load events dispatched by DownloadMesh / LibraryAsset
  // after a pivot is added to the scene.  scene.children mutations are invisible
  // to React, so this event is the reliable trigger to re-run child extraction.
  useEffect(() => {
    const runGlbExtraction = (meshList) => {
      if (!meshList?.length) return;
      setGLBMeshes((prev) => {
        const next = { ...prev };
        meshList.forEach((meshAsset) => {
          const pathOrName =
            meshAsset.asset_file_path ||
            meshAsset.file_name ||
            meshAsset.url ||
            '';
          const isGlb =
            typeof pathOrName === 'string' &&
            pathOrName.toLowerCase().includes('.glb');
          if (!isGlb) return;

          const key = meshAsset._id || meshAsset.name;
          const meshes = memoizedExtractMeshesFromGLB(meshAsset);
          if (meshes.length > 0) {
            next[key] = meshes;
          }
        });
        return next;
      });
    };

    const handleGLBMeshLoaded = () => {
      // Read fresh mesh list directly from the Redux store to avoid stale closure —
      // the glbMeshLoaded event fires synchronously right after dispatch so the React
      // component (assets_data.mesh) hasn't re-rendered with the new entry yet.
      const freshMeshList = store.getState()?.assets_object?.assets_data?.mesh;
      runGlbExtraction(freshMeshList || assets_data?.mesh);

      // Second pass after a short delay to catch async-loading geometry
      // (e.g. duplicate: Three.js pivot may still be cloning geometry at event time)
      setTimeout(() => {
        const latestMeshList = store.getState()?.assets_object?.assets_data?.mesh;
        runGlbExtraction(latestMeshList || assets_data?.mesh);
      }, 500);
    };

    window.addEventListener('glbMeshLoaded', handleGLBMeshLoaded);
    return () => {
      window.removeEventListener('glbMeshLoaded', handleGLBMeshLoaded);
    };
  }, [assets_data?.mesh, memoizedExtractMeshesFromGLB]);

  // Auto-scroll to selected item when Redux selection changes
  // This syncs scene clicks with left panel by auto-scrolling to matching item
  // Efficient for large lists (8000+ objects) using UUID-based matching
  useEffect(() => {
    if (!select_object || !containerRef.current) return;

    const selectedUuid = select_object.uuid;
    const selectedName = select_object.name;

    if (!selectedUuid && !selectedName) return;

    let needsExpansion = false;
    let expansionDelay = 100;

    // Deep-expand hierarchy only while child-selection mode is on (after parent double-click)
    if (isChildSelectionEnabled()) {
      for (const [glbId, roots] of Object.entries(glbMeshes)) {
        if (
          selectedUuid &&
          !glbPivotContainsObjectUuid(scene, glbId, selectedUuid)
        ) {
          continue;
        }

        const expandPath = collectGlbHierarchyExpandKeys(roots, {
          uuid: selectedUuid,
          name: selectedName,
          glbRootId: glbId,
        });

        if (expandPath?.length) {
          setExpandedGLBs((prev) => {
            const newSet = new Set(prev);
            newSet.add(glbId);
            expandPath.forEach((key) => newSet.add(key));
            return newSet;
          });
          needsExpansion = true;
          expansionDelay = 120 + expandPath.length * 40;
          break;
        }
      }
    }

    const scrollToElement = () => {
      if (!containerRef.current) return;
      let element = null;

      if (selectedUuid) {
        element = containerRef.current.querySelector(
          `[data-object-uuid="${selectedUuid}"]`
        );
      }
      if (!element && selectedName) {
        element = containerRef.current.querySelector(
          `[data-object-name="${selectedName}"]`
        );
      }

      if (element) {
        element.scrollIntoView({
          behavior: 'auto',
          block: 'nearest',
          inline: 'nearest',
        });
      }
    };

    if (needsExpansion) {
      setTimeout(scrollToElement, expansionDelay);
    } else {
      scrollToElement();
    }
  }, [select_object?.uuid, select_object?.name, glbMeshes, scene]);

  // Select individual mesh within GLB (only when child-selection mode is enabled)
  const selectGLBMesh = (mesh) => {
    if (!mesh?.object) return;
    if (!isChildSelectionEnabled()) {
      const parentId = mesh.parentGLB?._id || mesh.parentGLB?.name;
      const pivot = parentId ? scene.getObjectByName(parentId) : null;
      if (pivot) {
        selectObjectInScene(pivot);
        setSelectedObjectState(pivot);
      }
      return;
    }
    const target = clampSelectionForChildMode(
      scene,
      mesh.object,
      getActiveParentForChildSelection()
    );
    store.dispatch(selected_object(target));
    selectObjectInScene(target);
    setSelectedObjectState(target);
  };
  const handleDuplicate = async (item, arrKey, originalMesh = null) => {
    const beforeSnapshot = scene ? captureDiscreteHistoryBefore(scene) : null;
    const endSuppress = suppressGridHistory();

    try {
      const sourceMesh = resolveMeshInScene(scene, item, originalMesh);
      if (arrKey === 'image')
        duplicateImageAsset(item, objectt, undefined, sourceMesh);
      else if (arrKey === 'mesh')
        duplicateMeshAsset(item, objectt, undefined, sourceMesh);
      else if (arrKey === 'video')
        duplicateVideoAsset(item, objectt, undefined, sourceMesh);
      else if (arrKey === 'audio')
        duplicateAudioAsset(item, objectt, undefined, sourceMesh);
      else if (arrKey === 'text') {
        const textMesh =
          sourceMesh || resolveLiveSceneObject(scene, item, 'text');
        await handleAddText(
          { ...objectt, selectedObject: textMesh || item },
          item,
          'duplicate'
        );
      } else if (arrKey === 'light') handleDuplicateLight(item);
      else if (arrKey === 'camera') handleDuplicateCamera(item);
      else if (arrKey === 'particle') duplicateParticleAsset(item, objectt);
      else if (arrKey === 'empty') handleDuplicateEmpty(item);
      else if (arrKey === 'hotspot') handleDuplicateHotspot(item);
    } finally {
      endSuppress();
      if (beforeSnapshot && scene) {
        recordDiscreteHistoryAfter(beforeSnapshot, scene, 'duplicate');
      }
    }

    setselectedPop('');
  };

  return (
    <div
      ref={containerRef}
      className="overflow-hidden h-full "
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDropToRoot}
    >
      <div className="h-full gap-2 flex flex-col overflow-visible scrollbar-none">
        <div className="w-full gap-2 flex flex-col">
          <div className="flex w-full justify-between">
            <div className="section-header-content">
              <h3 className="section-title">Scenes</h3>
              <img
                className="section-title-img"
                src={iconsPath?.vector6Image}
                alt=""
              />
            </div>
            <button className="add-btn">
              <img
                className="add-btn-img"
                src={iconsPath?.group7Image}
                alt=""
              />
            </button>
          </div>
          <ul className="flex w-full justify-between bg-[#1d1e21]">
            <li className="section-item">
              <span className="check-icon">
                <img
                  className="check-icon-img"
                  src={iconsPath?.group4Image}
                  alt=""
                />
              </span>
              <span style={{ paddingRight: '24px' }}>Scene 1</span>
            </li>
          </ul>
        </div>

        {referenceInfo.present && (
          <>
            <img className="left-divider" src={iconsPath?.line7Image} alt="" />
            <div className="w-full gap-2 flex flex-col">
              {/* <div className="section-header">
                <h3 className="section-title">{REFERENCE_OBJECT_LABEL}</h3>
              </div> */}
              <ul className="flex w-full justify-between items-center bg-[#1d1e21]">
                <li className="section-item flex-1">
                  <span style={{ paddingRight: '24px' }}>
                    {REFERENCE_OBJECT_LABEL} object
                  </span>
                </li>
                <AssetVisibilityToggle
                  visible={referenceInfo.visible}
                  onToggle={handleToggleReferenceVisibility}
                  className="mr-2"
                />
              </ul>
            </div>
          </>
        )}

        <img className="left-divider" src={iconsPath?.line7Image} alt="" />
        <div className="section-header">
          <h3 className="section-title">Assets</h3>
          <button
            className="add-btn"
            onClick={(e) => {
              e.stopPropagation();
              setAssetsPopup('add-assets');
              const rect = e.currentTarget.getBoundingClientRect();
              setAssetsPopupPosition({
                top: rect.top - 10,
                left: rect.right + 10,
              });
            }}
          >
            <img
              className="add-btn-img"
              src={iconsPath?.group8Image}
              alt="Add"
            />
          </button>
        </div>

        <div className="w-full gap-2 flex flex-col h-full overflow-y-auto scrollbar-none">
          {assetsPopup === 'add-assets' && (
            <SubMenuPortal position={assetsPopupPosition}>
              <div
                ref={outSideRef}
                className="absolute top-0 -right-[88px] bg-[#1d1e21] text-white text-[10px] rounded shadow-md w-[85px] mt-[10px] text-left !z-[99999999999] flex flex-col"
              >
                <button
                  onClick={handleAddCamera}
                  className="py-[4px] px-[14px] text-nowrap text-left hover:bg-[#2a2a2a]"
                >
                  Add Camera
                </button>
                <button
                  onClick={() => {
                    EmptyObject({
                      scene,
                      dispatch,
                      selectObjectInScene,
                      setSelectedObjectState,
                      assets_data,
                    });
                    setAssetsPopup(null);
                  }}
                  className="py-[4px] px-[14px] text-nowrap text-left hover:bg-[#2a2a2a]"
                >
                  Create Empty
                </button>
              </div>
            </SubMenuPortal>
          )}
          <div className="assets-container">
            <ul className="flex w-full flex-col justify-between gap-1 relative">
              <div
                className="assets-container flex-grow min-h-[100px]"
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDropToRoot}
              >
                <ul className="flex w-full flex-col justify-between">
                  {/* Cameras, Lights, and Particles - Unified System */}
                  {allAssets
                    ?.filter(({ type }) =>
                      ['camera', 'light', 'particle'].includes(type)
                    )
                    ?.map(({ item, type }, index) => {
                      const itemId =
                        type === 'camera'
                          ? getCameraStableId(item)
                          : item._id || item.id;
                      const itemObj =
                        type === 'camera'
                          ? resolveSceneCameraObject(scene, item) ||
                            scene.getObjectByName(itemId)
                          : scene.getObjectByName(itemId);

                      // Check if this item is a child of another asset
                      const isChildAsset =
                        (itemObj &&
                          itemObj.parent &&
                          itemObj.parent !== scene) ||
                        (item.parent &&
                          item.parent !== 'scene' &&
                          item.parent !== scene);

                      // Skip rendering if this item is a child
                      if (isChildAsset) {
                        return null;
                      }

                      const hasAssetChildren = itemObj
                        ? findDirectChildrenAssets(itemObj).length > 0
                        : false;

                      const isLastInCategory =
                        index ===
                        allAssets.filter(({ type }) =>
                          ['camera', 'light', 'particle'].includes(type)
                        ).length -
                          1;
                      const hasNextCategoryWithItems =
                        assets_data?.image?.length > 0 ||
                        assets_data?.mesh?.length > 0 ||
                        assets_data?.video?.length > 0 ||
                        assets_data?.audio?.length > 0 ||
                        assets_data?.text?.length > 0 ||
                        assets_data?.hotspot?.length > 0;

                      return (
                        <React.Fragment key={`${type}-${itemId}`}>
                          <RecursiveChildRenderer
                            item={item}
                            type={type}
                            level={0}
                            isLast={
                              isLastInCategory && !hasNextCategoryWithItems
                            }
                            scene={scene}
                            findDirectChildrenAssets={findDirectChildrenAssets}
                            expandedGLBs={expandedGLBs}
                            setExpandedGLBs={setExpandedGLBs}
                            select_object={select_object}
                            selectObjectInScene={selectObjectInScene}
                            selectGLBMesh={selectGLBMesh}
                            selectedPop={selectedPop}
                            setselectedPop={setselectedPop}
                            submenuPosition={submenuPosition}
                            setSubmenuPosition={setSubmenuPosition}
                            setSelectedGLBMeshPop={setSelectedGLBMeshPop}
                            setGLBMeshSubmenuPosition={
                              setGLBMeshSubmenuPosition
                            }
                            // Light-specific popup state
                            selectedLightPop={selectedLightPop}
                            setSelectedLightPop={setSelectedLightPop}
                            lightSubmenuPosition={lightSubmenuPosition}
                            setLightSubmenuPosition={setLightSubmenuPosition}
                            isRenamingLight={isRenamingLight}
                            setIsRenamingLight={setIsRenamingLight}
                            renamingLight={renamingLight}
                            setRenamingLight={setRenamingLight}
                            newLightName={newLightName}
                            setNewLightName={setNewLightName}
                            objectt={objectt}
                            getAssetIcon={getAssetIcon}
                            iconsPath={iconsPath}
                            shapesIcon={shapesIcon}
                            assetIcons={assetIcons}
                            setDraggingAssetId={setDraggingAssetId}
                            setHoverTargetAssetId={setHoverTargetAssetId}
                            handleDropOnAsset={handleDropOnAsset}
                            parentKey=""
                            glbMeshes={glbMeshes}
                            extractMeshesFromGLB={memoizedExtractMeshesFromGLB}
                            setGLBMeshes={setGLBMeshes}
                            // Pass delete handlers
                            handleRemoveLight={handleRemoveLight}
                            handleRemoveParticle={handleRemoveParticle}
                            handleRemoveCamera={handleRemoveCamera}
                            handleDuplicate={handleDuplicate}
                            deleteAllChildren={deleteAllChildren}
                            cleanupParentReferences={cleanupParentReferences}
                            dispatch={dispatch}
                            store={store}
                            assets_data={assets_data}
                            light_data={light_data}
                            particles={particles}
                            selectedObject={selectedObject}
                            setSelectedObjectState={setSelectedObjectState}
                            outSideRef={outSideRef}
                            // Unified handlers
                            handleUnifiedMenuClick={handleUnifiedMenuClick}
                            handleUnifiedRename={handleUnifiedRename}
                            handleUnifiedDuplicate={handleUnifiedDuplicate}
                            handleUnifiedDelete={handleUnifiedDelete}
                            unifiedPopup={unifiedPopup}
                            setUnifiedPopup={setUnifiedPopup}
                            unifiedRename={unifiedRename}
                            setUnifiedRename={setUnifiedRename}
                            handleRenameSubmit={handleRenameSubmit}
                            DeleteMesh={DeleteMesh}
                            handleVisibilityToggle={handleVisibilityToggle}
                          />
                        </React.Fragment>
                      );
                    })}
                </ul>

                {/* Assets */}
                {['image', 'mesh', 'video', 'audio', 'text', 'hotspot'].map(
                  (arrKey, ind) => (
                    <React.Fragment key={ind}>
                      {(assets_data?.[arrKey] || [])
                        .filter((v) =>
                          shouldShowAssetInLeftPanel(scene, v, arrKey)
                        )
                        .filter((v, idx, arr) => {
                          const id = resolveAssetRowId(v) || v?.uuid;
                          const firstIdx = arr.findIndex(
                            (x) => (resolveAssetRowId(x) || x?.uuid) === id
                          );
                          return firstIdx === idx;
                        })
                        .map((v, i) => {
                          const vId = resolveAssetRowId(v);
                          const vObj = resolveLiveSceneObject(scene, v, arrKey);

                          // Check if this asset is a child of another asset.
                          // Only treat string Redux `parent` ids as hierarchy — Object3D.parent
                          // is the live Three.js parent and must not hide scene-root duplicates.
                          const reduxParent =
                            typeof v.parent === 'string' ? v.parent : null;
                          const isChildAsset =
                            (vObj && vObj.parent && vObj.parent !== scene) ||
                            (reduxParent &&
                              reduxParent !== 'scene' &&
                              reduxParent !== scene);

                          // Skip rendering if this asset is a child
                          if (isChildAsset) {
                            return null;
                          }

                          const isGLB =
                            arrKey === 'mesh' &&
                            (v.file_name?.toLowerCase().includes('.glb') ||
                              v.url?.toLowerCase().includes('.glb') ||
                              v?.asset_file_path
                                ?.toLowerCase()
                                .includes('.glb'));
                          const glbId = v._id || v.name;
                          const hasChildren =
                            isGLB &&
                            glbMeshes[glbId] &&
                            glbMeshes[glbId].length > 0;

                          const isExpanded = expandedGLBs.has(glbId);
                          const isHovered = hoverTargetAssetId === vId;
                          const hasAssetChildren = vObj
                            ? findDirectChildrenAssets(vObj).length > 0
                            : false;

                          const isLastInCategory =
                            i === assets_data[arrKey].length - 1;

                          const hasNextCategoryWithItems =
                            [
                              'image',
                              'mesh',
                              'video',
                              'audio',
                              'text',
                              'hotspot',
                              'particle',
                            ]
                              .slice(ind + 1)
                              .some(
                                (nextKey) => assets_data?.[nextKey]?.length > 0
                              ) || particles.length > 0;
                          const isLastOverall =
                            isLastInCategory && !hasNextCategoryWithItems;

                          return (
                            <React.Fragment key={i}>
                              <li
                                draggable={
                                  arrKey !== 'hotspot' &&
                                  v?.deleteType !== 'hotspot' &&
                                  !v?.userData?.isHotspot
                                }
                                data-object-uuid={vObj?.uuid || v?.uuid}
                                data-object-name={vId || vObj?.name || v?.name}
                                onClick={(e) => {
                                  handleGridItemClick(e, v, arrKey, () => {
                                    const target =
                                      vObj ||
                                      resolveLiveSceneObject(
                                        scene,
                                        {
                                          ...v,
                                          _id: vId,
                                          id: vId,
                                          name: vId,
                                          url: vId,
                                        },
                                        arrKey
                                      );
                                    if (!target && !vId) return;
                                    selectObjectInScene(target || vId);
                                    if (target) {
                                      setSelectedObjectState(target);
                                      objectt?.transformControls?.attach(
                                        target
                                      );
                                    }
                                  });
                                }}
                                onDoubleClick={() => {
                                  const parentObj = scene.getObjectByName(vId);
                                  if (
                                    parentObj &&
                                    (hasAssetChildren || hasChildren)
                                  ) {
                                    const enabled =
                                      toggleChildSelectionMode(parentObj);
                                    console.log(
                                      `[Child Selection] ${enabled ? 'Enabled' : 'Disabled'} for parent:`,
                                      parentObj.name || vId
                                    );

                                    // Auto-expand if not already expanded
                                    if (!isExpanded) {
                                      const newSet = new Set(expandedGLBs);
                                      newSet.add(glbId);

                                      // Extract GLB meshes if needed
                                      if (
                                        isGLB &&
                                        memoizedExtractMeshesFromGLB &&
                                        !glbMeshes[glbId]
                                      ) {
                                        const meshes =
                                          memoizedExtractMeshesFromGLB(v);
                                        if (meshes.length > 0) {
                                          setGLBMeshes((prev) => ({
                                            ...prev,
                                            [glbId]: meshes,
                                          }));
                                        }
                                      }
                                      setExpandedGLBs(newSet);
                                    }
                                  }
                                }}
                                onDragStart={(e) => {
                                  if (
                                    arrKey === 'hotspot' ||
                                    v?.deleteType === 'hotspot' ||
                                    v?.userData?.isHotspot
                                  ) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    return;
                                  }
                                  setDraggingAssetId(vId);

                                  e.dataTransfer.setData(
                                    'application/json',
                                    JSON.stringify({
                                      id: v._id || v?.url || v?.name,
                                      name:
                                        v.file_name ||
                                        v?.name ||
                                        v?.asset_file_name ||
                                        v?.temp_file_name ||
                                        'Asset',
                                      type: arrKey,
                                      icon: getAssetIcon(v, arrKey),
                                      properties: {
                                        position: true,
                                        scale: true,
                                        rotation: true,
                                      },
                                    })
                                  );
                                }}
                                onDragEnd={() => setDraggingAssetId(null)}
                                onDragOver={(e) => {
                                  if (
                                    arrKey === 'hotspot' ||
                                    v?.deleteType === 'hotspot' ||
                                    v?.userData?.isHotspot
                                  ) {
                                    return;
                                  }
                                  e.preventDefault();
                                  setHoverTargetAssetId(vId);
                                }}
                                onDragLeave={() =>
                                  setHoverTargetAssetId((prev) =>
                                    prev === vId ? null : prev
                                  )
                                }
                                onDrop={(e) => {
                                  if (
                                    arrKey === 'hotspot' ||
                                    v?.deleteType === 'hotspot' ||
                                    v?.userData?.isHotspot
                                  ) {
                                    e.preventDefault();
                                    return;
                                  }
                                  handleDropOnAsset(v, e);
                                }}
                                className={`cursor-pointer flex justify-between gap-5 min-w-full w-max text-white py-1 pl-2 rounded relative ${
                                  isRowSelected(v, arrKey)
                                    ? 'bg-[#ffffff1a]'
                                    : ''
                                } pr-0`}
                              >
                                {/* Vertical Line */}
                                {!isGLB ? (
                                  <div
                                    className="absolute left-[7px] top-0 w-[1px] bg-[#444447] z-[1]"
                                    style={{
                                      height: isLastOverall ? '50%' : '100%',
                                    }}
                                  />
                                ) : (
                                  <>
                                    <div
                                      className="absolute left-[7px] top-0 w-[1px] bg-[#444447] z-[1]"
                                      style={{
                                        // When a GLB is expanded, stop the connector so it doesn't
                                        // continue below into the next sibling (matches extraction UI).
                                        height:
                                          isLastOverall ||
                                          (isExpanded &&
                                            (hasChildren || hasAssetChildren))
                                            ? '50%'
                                            : '100%',
                                      }}
                                    />
                                  </>
                                )}

                                {/* Horizontal Line - hide only for root level items (level 0) with children */}
                                {!(hasChildren || hasAssetChildren) && (
                                  <div className="absolute left-[7px] top-1/2 w-[14px] h-[1px] bg-[#444447] z-[1]" />
                                )}

                                <div className="flex gap-[10px] items-center flex-1 min-w-0">
                                  {hasAssetChildren || hasChildren ? (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent parent onClick
                                        const newSet = new Set(expandedGLBs);
                                        if (newSet.has(glbId)) {
                                          newSet.delete(glbId);
                                        } else {
                                          newSet.add(glbId);
                                        }
                                        setExpandedGLBs(newSet);
                                      }}
                                      className="w-3 h-3 flex relative right-[7px] items-center justify-center border border-[#444447] z-[9999] rounded-sm bg-[#1d1e21]"
                                    >
                                      <img
                                        src={iconsPath.rightIcon}
                                        alt="Toggle"
                                        className={`w-2 h-2 transform transition-transform duration-200 ${
                                          isExpanded ? 'rotate-90' : 'rotate-0'
                                        }`}
                                      />
                                    </button>
                                  ) : (
                                    <div className="w-3" />
                                  )}
                                  <img
                                    src={getAssetIcon(v, arrKey)}
                                    className="w-[16px] h-[16px] object-contain flex-shrink-0"
                                    alt={`${arrKey} icon`}
                                  />
                                  {unifiedRename.isRenaming &&
                                  unifiedRename.assetId === vId ? (
                                    <input
                                      ref={renameInputRef}
                                      type="text"
                                      value={unifiedRename.newName}
                                      onChange={(e) =>
                                        setUnifiedRename({
                                          ...unifiedRename,
                                          newName: e.target.value,
                                        })
                                      }
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                          handleRenameSubmit();
                                        } else if (e.key === 'Escape') {
                                          setUnifiedRename({
                                            isRenaming: false,
                                            assetId: null,
                                            assetType: null,
                                            newName: '',
                                            assetItem: null,
                                          });
                                        }
                                      }}
                                      onBlur={() => {
                                        if (unifiedRename.newName.trim()) {
                                          handleRenameSubmit();
                                        } else {
                                          setUnifiedRename({
                                            isRenaming: false,
                                            assetId: null,
                                            assetType: null,
                                            newName: '',
                                            assetItem: null,
                                          });
                                        }
                                      }}
                                      className="w-full bg-[#444447] text-white text-[10px] px-2 py-1 rounded focus:outline-none ml-[4px]"
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                  ) : (
                                    <SimpleAssetTooltip
                                      label={
                                        v?.file_name ||
                                        v?.asset_file_name ||
                                        'Asset'
                                      }
                                    >
                                      <div className="flex items-center min-w-0 pr-2">
                                        <span
                                          className="text-[10px] text-left truncate"
                                          style={{
                                            whiteSpace: 'nowrap',
                                            display: 'block',
                                          }}
                                        >
                                          {v?.file_name ||
                                            v?.asset_file_name ||
                                            'Asset'}
                                        </span>
                                      </div>
                                    </SimpleAssetTooltip>
                                  )}
                                </div>

                                {/* Options menu */}
                                <div
                                  className={`sticky right-0 flex-shrink-0 z-[10] flex items-center justify-between min-w-[46px] pl-2 pr-1 ${isRowSelected(v, arrKey) ? 'bg-[#2b2c2f]' : 'bg-[#131418]'}`}
                                >
                                  <AssetVisibilityToggle
                                    visible={isAssetVisible(
                                      v,
                                      vObj ||
                                        resolveSceneObject(scene, v, arrKey)
                                    )}
                                    onToggle={() =>
                                      handleVisibilityToggle(
                                        v,
                                        arrKey,
                                        arrKey,
                                        vId
                                      )
                                    }
                                  />
                                  <img
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevent parent onClick from firing twice
                                      // First select the item
                                      const menuTarget =
                                        vObj ||
                                        resolveLiveSceneObject(
                                          scene,
                                          {
                                            ...v,
                                            _id: vId,
                                            id: vId,
                                            name: vId,
                                            url: vId,
                                          },
                                          arrKey
                                        );
                                      selectObjectInScene(menuTarget || vId);
                                      if (menuTarget) {
                                        setSelectedObjectState(menuTarget);
                                        objectt?.transformControls?.attach(
                                          menuTarget
                                        );
                                      }
                                      // Then open the menu
                                      handleUnifiedMenuClick(e, vId, arrKey, v);
                                    }}
                                    src={iconsPath.threeDots}
                                    className="w-[12px] cursor-pointer hover:opacity-70 flex-shrink-0"
                                    alt="Options"
                                  />
                                </div>

                                {/* Unified popup for regular assets */}
                                {unifiedPopup.isOpen &&
                                  unifiedPopup.assetId === vId && (
                                    <SubMenuPortal
                                      position={unifiedPopup.position}
                                    >
                                      <div
                                        ref={outSideRef}
                                        className="absolute top-0 -right-[6rem] bg-[#1d1e21] text-white text-[10px] rounded shadow-md w-[85px] mt-[10px] text-left !z-[99999999999] flex flex-col"
                                      >
                                        <button
                                          onClick={() =>
                                            handleUnifiedRename(vId, arrKey, v)
                                          }
                                          className="py-[4px] px-[14px] text-left hover:bg-[#2a2a2a]"
                                        >
                                          Rename
                                        </button>
                                        <button
                                          onClick={() =>
                                            handleUnifiedDuplicate(
                                              vId,
                                              arrKey,
                                              v
                                            )
                                          }
                                          className="py-[4px] px-[14px] text-left hover:bg-[#2a2a2a]"
                                        >
                                          Duplicate
                                        </button>
                                        <button
                                          onClick={() =>
                                            handleUnifiedDelete(vId, arrKey, v)
                                          }
                                          className="py-[4px] px-[14px] text-left hover:bg-[#2a2a2a]"
                                        >
                                          Delete
                                        </button>
                                      </div>
                                    </SubMenuPortal>
                                  )}
                              </li>

                              {/* Children Rendering */}
                              {/* Children Rendering */}
                              {isExpanded &&
                                (hasChildren || hasAssetChildren) && (
                                  <div className="relative">
                                    {(() => {
                                      let children = [];
                                      const glbOriginal =
                                        scene.getObjectByName(glbId);

                                      // Hash map to prevent ALL duplicate children
                                      // Use scene object UUIDs as primary key for reliable deduplication
                                      const processedChildrenIds = new Set();
                                      const processedSceneObjects = new Set(); // Track by scene object UUID

                                      // 1. For Asset children (including particles) - PROCESS FIRST to prioritize original names
                                      if (hasAssetChildren && vObj) {
                                        const rawAssetChildren =
                                          findDirectChildrenAssets(vObj);

                                        // Sort to prioritize items with original names over temp_file_name
                                        // Items with name/_id come first, items with only temp_file_name come last
                                        const sortedChildren = [
                                          ...rawAssetChildren,
                                        ].sort((a, b) => {
                                          const aHasOriginal = !!(
                                            a.item.name ||
                                            a.item._id ||
                                            a.item.id
                                          );
                                          const bHasOriginal = !!(
                                            b.item.name ||
                                            b.item._id ||
                                            b.item.id
                                          );
                                          const aHasOnlyTemp =
                                            !!a.item.temp_file_name &&
                                            !aHasOriginal;
                                          const bHasOnlyTemp =
                                            !!b.item.temp_file_name &&
                                            !bHasOriginal;

                                          // Items with original identifiers come first
                                          if (aHasOriginal && !bHasOriginal)
                                            return -1;
                                          if (!aHasOriginal && bHasOriginal)
                                            return 1;
                                          // Among items with only temp_file_name, they stay in original order
                                          return 0;
                                        });

                                        sortedChildren.forEach(
                                          ({ item, type }, index) => {
                                            // Prioritize original identifiers over temp_file_name when looking up scene object
                                            const childObj =
                                              (item._id
                                                ? scene.getObjectByName(
                                                    item._id
                                                  )
                                                : null) ||
                                              (item.id
                                                ? scene.getObjectByName(item.id)
                                                : null) ||
                                              (item.name
                                                ? scene.getObjectByName(
                                                    item.name
                                                  )
                                                : null) ||
                                              (item.url
                                                ? scene.getObjectByName(
                                                    item.url
                                                  )
                                                : null) ||
                                              (item.temp_file_name
                                                ? scene.getObjectByName(
                                                    item.temp_file_name
                                                  )
                                                : null);

                                            const childUuid = childObj?.uuid;

                                            // Check if this scene object has already been processed (by UUID)
                                            // This ensures we skip temp_file_name versions if original name version was processed first
                                            if (
                                              childUuid &&
                                              processedSceneObjects.has(
                                                childUuid
                                              )
                                            ) {
                                              return; // Skip - already processed (original name version was processed first)
                                            }

                                            // Prioritize original name/_id over temp_file_name for display
                                            const childId =
                                              item._id ||
                                              item.id ||
                                              item.name ||
                                              item.url ||
                                              item.temp_file_name ||
                                              childUuid;

                                            // Get all possible identifiers
                                            const allChildIds = [
                                              childUuid,
                                              item._id,
                                              item.id,
                                              item.name,
                                              item.url,
                                              item.temp_file_name,
                                              childObj?.name,
                                              childObj?._id,
                                              childObj?.id,
                                            ].filter(Boolean);

                                            // Skip if any identifier has been processed
                                            const isAlreadyProcessed =
                                              allChildIds.some((id) =>
                                                processedChildrenIds.has(id)
                                              );

                                            if (!isAlreadyProcessed) {
                                              // Mark all identifiers as processed
                                              allChildIds.forEach((id) =>
                                                processedChildrenIds.add(id)
                                              );
                                              if (childUuid) {
                                                processedSceneObjects.add(
                                                  childUuid
                                                );
                                              }

                                              // Validate child has required data
                                              if (item) {
                                                children.push({
                                                  type: type,
                                                  data: item,
                                                  index: children.length,
                                                  isLast: false,
                                                  key: `${vId}-asset-child-${childUuid || childId}`,
                                                });
                                              }
                                            }
                                          }
                                        );
                                      }

                                      // 2. For GLB meshes - PROCESS SECOND (skips assets already claimed in Step 1)
                                      if (hasChildren && glbMeshes[glbId]) {
                                        glbMeshes[glbId].forEach(
                                          (mesh, index) => {
                                            // Get the actual scene object
                                            const meshObj = mesh.object;
                                            const meshUuid = meshObj?.uuid;
                                            const meshId =
                                              mesh.id || mesh.name || mesh.uuid;

                                            // Get all possible identifiers for this mesh
                                            const allMeshIds = [
                                              meshUuid,
                                              meshId,
                                              meshObj?.name,
                                              meshObj?._id,
                                              meshObj?.id,
                                              meshObj?.temp_file_name,
                                              mesh.name,
                                            ].filter(Boolean);

                                            // Check if this scene object has already been processed
                                            const isAlreadyProcessed =
                                              (meshUuid &&
                                                processedSceneObjects.has(
                                                  meshUuid
                                                )) ||
                                              allMeshIds.some((id) =>
                                                processedChildrenIds.has(id)
                                              );

                                            if (!isAlreadyProcessed) {
                                              // Mark all identifiers as processed
                                              allMeshIds.forEach((id) =>
                                                processedChildrenIds.add(id)
                                              );
                                              if (meshUuid) {
                                                processedSceneObjects.add(
                                                  meshUuid
                                                );
                                              }

                                              children.push({
                                                type: 'mesh',
                                                data: mesh,
                                                index: children.length,
                                                isLast: false,
                                                key: `${glbId}-mesh-${meshUuid || meshId}`,
                                              });
                                            }
                                          }
                                        );
                                      }

                                      // Update isLast flag for all children
                                      if (children.length > 0) {
                                        children[children.length - 1].isLast =
                                          true;
                                      }

                                      return children.map((child) => (
                                        <RecursiveChildRenderer
                                          key={child.key}
                                          item={child.data}
                                          type={child.type}
                                          level={1}
                                          isLast={child.isLast}
                                          scene={scene}
                                          glbRootId={glbId}
                                          findDirectChildrenAssets={
                                            findDirectChildrenAssets
                                          }
                                          expandedGLBs={expandedGLBs}
                                          setExpandedGLBs={setExpandedGLBs}
                                          select_object={select_object}
                                          selectObjectInScene={
                                            selectObjectInScene
                                          }
                                          selectGLBMesh={selectGLBMesh}
                                          selectedPop={selectedPop}
                                          setselectedPop={setselectedPop}
                                          submenuPosition={submenuPosition}
                                          setSubmenuPosition={
                                            setSubmenuPosition
                                          }
                                          setSelectedGLBMeshPop={
                                            setSelectedGLBMeshPop
                                          }
                                          setGLBMeshSubmenuPosition={
                                            setGLBMeshSubmenuPosition
                                          }
                                          selectedLightPop={selectedLightPop}
                                          setSelectedLightPop={
                                            setSelectedLightPop
                                          }
                                          lightSubmenuPosition={
                                            lightSubmenuPosition
                                          }
                                          setLightSubmenuPosition={
                                            setLightSubmenuPosition
                                          }
                                          isRenamingLight={isRenamingLight}
                                          setIsRenamingLight={
                                            setIsRenamingLight
                                          }
                                          renamingLight={renamingLight}
                                          setRenamingLight={setRenamingLight}
                                          newLightName={newLightName}
                                          setNewLightName={setNewLightName}
                                          getAssetIcon={getAssetIcon}
                                          iconsPath={iconsPath}
                                          shapesIcon={shapesIcon}
                                          assetIcons={assetIcons}
                                          setDraggingAssetId={
                                            setDraggingAssetId
                                          }
                                          setHoverTargetAssetId={
                                            setHoverTargetAssetId
                                          }
                                          handleDropOnAsset={handleDropOnAsset}
                                          parentKey={vId}
                                          glbMeshes={glbMeshes}
                                          extractMeshesFromGLB={
                                            memoizedExtractMeshesFromGLB
                                          }
                                          setGLBMeshes={setGLBMeshes}
                                          handleRemoveLight={handleRemoveLight}
                                          handleRemoveParticle={
                                            handleRemoveParticle
                                          }
                                          handleRemoveCamera={
                                            handleRemoveCamera
                                          }
                                          handleDuplicate={handleDuplicate}
                                          deleteAllChildren={deleteAllChildren}
                                          cleanupParentReferences={
                                            cleanupParentReferences
                                          }
                                          dispatch={dispatch}
                                          store={store}
                                          assets_data={assets_data}
                                          light_data={light_data}
                                          particles={particles}
                                          selectedObject={selectedObject}
                                          setSelectedObjectState={
                                            setSelectedObjectState
                                          }
                                          outSideRef={outSideRef}
                                          handleUnifiedMenuClick={
                                            handleUnifiedMenuClick
                                          }
                                          handleUnifiedRename={
                                            handleUnifiedRename
                                          }
                                          handleUnifiedDuplicate={
                                            handleUnifiedDuplicate
                                          }
                                          handleUnifiedDelete={
                                            handleUnifiedDelete
                                          }
                                          unifiedPopup={unifiedPopup}
                                          setUnifiedPopup={setUnifiedPopup}
                                          unifiedRename={unifiedRename}
                                          setUnifiedRename={setUnifiedRename}
                                          handleRenameSubmit={
                                            handleRenameSubmit
                                          }
                                          DeleteMesh={DeleteMesh}
                                          handleVisibilityToggle={
                                            handleVisibilityToggle
                                          }
                                          objectt={objectt}
                                        />
                                      ));
                                    })()}
                                  </div>
                                )}
                            </React.Fragment>
                          );
                        })}
                    </React.Fragment>
                  )
                )}

                {/* Empty Objects */}
                {assets_data?.empty?.map((emptyObj, i) => {
                  const emptyId =
                    emptyObj._id || emptyObj?.id || emptyObj?.name;
                  const emptyObjInScene = scene.getObjectByName(emptyId);

                  if (
                    emptyObjInScene &&
                    emptyObjInScene.parent &&
                    emptyObjInScene.parent !== scene
                  ) {
                    return null;
                  }

                  const isLastEmpty = i === assets_data.empty.length - 1;

                  return (
                    <React.Fragment key={emptyId + i}>
                      <RecursiveChildRenderer
                        item={emptyObj}
                        type="empty"
                        level={0}
                        isLast={isLastEmpty}
                        parentKey=""
                        // Core functionality
                        scene={scene}
                        findDirectChildrenAssets={findDirectChildrenAssets}
                        selectObjectInScene={selectObjectInScene}
                        dispatch={dispatch}
                        store={store}
                        // Selection
                        select_object={select_object}
                        setSelectedObjectState={setSelectedObjectState}
                        // Hierarchy expansion
                        expandedGLBs={expandedGLBs}
                        setExpandedGLBs={setExpandedGLBs}
                        // Context menu
                        selectedPop={selectedPop}
                        setselectedPop={setselectedPop}
                        submenuPosition={submenuPosition}
                        setSubmenuPosition={setSubmenuPosition}
                        outSideRef={outSideRef}
                        // Icons
                        iconsPath={iconsPath}
                        getAssetIcon={getAssetIcon}
                        // Drag & Drop
                        setDraggingAssetId={setDraggingAssetId}
                        setHoverTargetAssetId={setHoverTargetAssetId}
                        handleDropOnAsset={handleDropOnAsset}
                        // Delete functionality
                        deleteAllChildren={deleteAllChildren}
                        cleanupParentReferences={cleanupParentReferences}
                        assets_data={assets_data}
                        light_data={light_data}
                        particles={particles}
                        // Unified handlers
                        handleUnifiedMenuClick={handleUnifiedMenuClick}
                        handleUnifiedRename={handleUnifiedRename}
                        handleUnifiedDuplicate={handleUnifiedDuplicate}
                        handleUnifiedDelete={handleUnifiedDelete}
                        unifiedPopup={unifiedPopup}
                        setUnifiedPopup={setUnifiedPopup}
                        unifiedRename={unifiedRename}
                        setUnifiedRename={setUnifiedRename}
                        handleRenameSubmit={handleRenameSubmit}
                        DeleteMesh={DeleteMesh}
                        handleVisibilityToggle={handleVisibilityToggle}
                      />
                    </React.Fragment>
                  );
                })}
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetsList;
